import React from 'react';
import PropTypes from 'prop-types';
import './Dashboard.scss';
import kumoJanai from './kumo-janai.svg';

const NotConnectedTile = (props) => {
  const { connected } = props.customerInfo;
  if (connected || props.hasError) {
    return null;
  }
  return (
    <div id="not-connected-tile" className="account-action-tile">
      <img
        src={kumoJanai}
        alt="Not Connected"
      />
      <br />
      <h4 className="account-action-tile-title">
        Welcome to Skinny Unlimited Broadband - we&apos;re glad you could join us
      </h4>
      <div className="account-action-tile-text">
        <p>
          It looks like we haven&apos;t got your connection up and running just yet.
          We are doing our best to get you connected and when we have we&apos;ll send you an email.
        </p>
        <p>
          Be sure to check back here to see the great features which are available on our dashboard once
          you are connected.
        </p>
      </div>
    </div>
  );
};

NotConnectedTile.propTypes = {
  customerInfo: PropTypes.shape().isRequired,
  hasError: PropTypes.bool
};

export default NotConnectedTile;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/Dashboard/NotConnectedTile.js
 **/